import { gql } from '@apollo/client';

const query = gql`
  mutation ($subscriptions: [TopicSubscription]) {
    updateNewsletterSubscription(subscriptions: $subscriptions)
  }
`;

export default query;
